import { SearchModule } from '@/src/app/features/search/search.module';
import { ScopeTreeComponent } from '@/src/app/features/user/components/scope-tree/scope-tree.component';
import { UserPersonalDataComponent } from '@/src/app/features/user/components/user-personal-data/user-personal-data.component';
import { UserProfileComponent } from '@/src/app/features/user/components/user-profile/user-profile.component';
import { UserSearchPageComponent } from '@/src/app/features/user/components/user-search-page/user-search-page.component';
import { UserSearchComponent } from '@/src/app/features/user/components/user-search/user-search.component';
import { UserPageComponent } from '@/src/app/features/user/components/user/user-page.component';
import { UsersRoutingModule } from '@/src/app/features/user/users-routing.module';

import { FormModule } from '@/src/app/shared/components/form/form.module';

import { GeneralCommonsModule } from '@/src/app/shared/modules/general-commons/general-commons.module';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { AuthenticationModule } from '@src/app/features/authentication/authentication.module';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    UsersRoutingModule,
    TranslateModule.forChild(),
    FormsModule,
    FormModule,
    SearchModule,
    GeneralCommonsModule,
    AuthenticationModule,
    UserSearchPageComponent,
    UserPersonalDataComponent,
    UserPageComponent,
    UserProfileComponent,
    ScopeTreeComponent,
    UserSearchComponent
  ],
  exports: []
})
export class UsersModule {}
